import { mapStyle } from './map_style'

let planePath = 'path://M1705.06,1318.313v-89.254l-319.9-221.799l0.073-208.063c0.521-84.662-26.629-121.796-63.961-121.491c-37.332-0.305-64.482,36.829-63.961,121.491l0.073,208.063l-319.9,221.799v89.254l330.343-157.288l12.238,241.308l-134.449,92.931l0.531,42.034l175.125-42.917l175.125,42.917l0.531-42.034l-134.449-92.931l12.238-241.308L1705.06,1318.313z'
let colors = ['#FFF7FF', '#FFBFFF', '#FF44FF', '#930093', '#9BCA63', '#FE8463', '#E87C25', '#F3A43B', '#F4E001', '#FAD860']

export const initOption = function ({legendData = ['客户', '工厂', '中心点'], row = ['干货', '新鲜货', '冰冻货']}) {
  let option = {}
  option.bmap = {
    center: [106.50, 29.56],
    zoom: 13,
    roam: true,
    mapStyle: {
      styleJson: mapStyle
    }
  }
  option.title = {
    id: 'title_select',
    text: '',
    left: '15%',
    bottom: '38%',
    width: 100,
    textStyle: {
      color: '#fff',
      fontSize: 16
    }
  }
  option.backgroundColor = '#404a59'
  option.legend = [{
    id: 'legend_point',
    orient: 'vertical',
    bottom: 20,
    right: 10,
    data: legendData,
    textStyle: {
      color: '#fff'
    }
  }]
  option.toolbox = {
    top: 10,
    right: 10,
    iconStyle: {
      normal: {
        borderColor: '#fff'
      },
      emphasis: {
        borderColor: '#b1e4ff'
      }
    },
    feature: {
      mark: {show: true},
      magicType: {show: true, type: ['stack', 'tiled']},
      restore: {show: true},
      saveAsImage: {show: true}
    }
  }
  option.xAxis = {
    type: 'value',
    scale: true,
    position: 'top',
    boundaryGap: false,
    splitLine: {
      show: false
    },
    axisLine: {
      show: false
    },
    axisTick: {
      show: false
    },
    axisLabel: {
      show: false,
      margin: 2,
      textStyle: {
        color: '#aaa'
      }
    }
  }
  option.yAxis = {
    show: false,
    data: [],
    type: 'category',
    nameTextStyle: {
      color: '#fff'
    }
  }
  option.grid = {
    left: '13%',
    bottom: 20,
    height: '30%',
    width: '20%'
  }
  // 圈选
  option.brush = {
    outOfBrush: {
      color: '#abc'
    },
    brushStyle: {
      borderWidth: 2,
      color: 'rgba(0,0,0,0.2)',
      borderColor: 'rgba(0,0,0,0.5)'
    },
    seriesIndex: 0,
    throttleType: 'debounce',
    throttleDelay: 300,
    geoIndex: 0
  }
  option.tooltip = {
    trigger: 'item',
    formatter: function (params) {
      let result = ''
      switch (params.seriesIndex) {
        case 0: {
          result = params.name + ' 需求:<br/>' + row[0] + params.value[2].dry + '/' + params.value[3].dry + ' <br/>' + row[1] + params.value[2].fresh + '/' + params.value[3].fresh + ' <br/>' + row[2] + params.value[2].frozen + '/' + params.value[3].frozen
          break
        }
        case 1: {
          result = params.name
          break
        }
        case 2: {
          result = params.name + '<br/>中心点:' + params.value[2].center + '<br/>顾客数：' + params.value[2].customer_num + '<br/>订货总量：' + params.value[2].order_num + '<br/>总距离：' + params.value[2].distance
          break
        }
        default: {
          result = params.seriesName + '<br/>' + params.data.fromName + '->' + params.data.toName
          break
        }
      }
      return result
    }
  }
  option.series = [{
    id: 'Location',
    name: legendData[0],
    type: 'scatter',
    coordinateSystem: 'bmap',
    symbolSize: 10,
    data: [],
    label: {
      normal: {
        formatter: '{b}',
        position: 'right',
        show: false
      }
    },
    itemStyle: {
      normal: {
        color: '#ffa022'
      }
    }
  },
  {
    id: 'Plant',
    name: legendData[1],
    type: 'scatter',
    coordinateSystem: 'bmap',
    symbolSize: 15,
    data: [],
    label: {
      normal: {
        formatter: '{b}',
        position: 'right',
        show: false
      }
    },
    itemStyle: {
      normal: {
        color: '#ff3333'
      }
    }
  },
  {
    id: 'centroids',
    name: legendData[2],
    type: 'scatter',
    coordinateSystem: 'bmap',
    symbolSize: 10,
    data: [],
    label: {
      normal: {
        formatter: '{b}',
        position: 'right',
        show: false
      }
    },
    itemStyle: {
      normal: {
        color: '#23c6c8'
      }
    }
  },
  {
    id: 'bar',
    zlevel: 2,
    type: 'bar',
    tooltip: {
      trigger: 'item',
      formatter: ' {b}<br/> 干货需求：<br/>{c}'
    },
    symbol: 'none',
    itemStyle: {
      normal: {
        color: '#5CADAD'
      }
    },
    data: []
  }]
  return option
}

let addList = function (datas) {
  datas = JSON.parse(datas)
  let sum = 0
  datas.forEach(function (item) {
    sum += item
  })
  return sum
}

export const initPreOption = function (legendData = ['加油站', '油库']) {
  let option = {}
  option.bmap = {
    center: [102.73, 25.04],
    zoom: 11,
    roam: true,
    mapStyle: {
      styleJson: mapStyle
    }
  }
  option.title = {
    id: 'title_select',
    text: '',
    left: '15%',
    bottom: '38%',
    width: 100,
    textStyle: {
      color: '#fff',
      fontSize: 16
    }
  }
  option.tooltip = {
    show: true,
    trigger: 'item',
    formatter: function (params) {
      let result = ''
      switch (params.seriesIndex) {
        case 0: {
          let str = ''
          if (params.value && params.value.length > 0) {
            params.value[3].forEach(function (item) {
              str += '<br/>' + '油品类型：' + item.type + ' 断货时间点: ' + item.dhsj
            })
          }
          result = params.name + str
          break
        }
        case 1: {
          result = params.name
          break
        }
        default: {
          result = params.seriesName + '<br/>' + params.data.fromName + ' -> ' + params.data.toName
          result += '<br/>油品：' + params.data.info[3]
          result += '<br/>配送时间窗：' + params.data.info[9] + ' -> ' + params.data.info[10]
          result += '<br/>配送量：' + addList(params.data.info[8]) + 'L 在途时间：' + params.data.info[12] + 'h'
          break
        }
      }
      return result
    }
  }
  option.backgroundColor = '#404a59'
  option.legend = [{
    id: 'legend_point',
    orient: 'vertical',
    bottom: 20,
    right: 10,
    data: legendData,
    textStyle: {
      color: '#fff'
    }
  }]
  option.series = [{
    id: 'Location',
    name: legendData[0],
    type: 'scatter',
    coordinateSystem: 'bmap',
    symbolSize: 10,
    data: [],
    label: {
      normal: {
        formatter: '{b}',
        position: 'right',
        show: false
      }
    },
    itemStyle: {
      normal: {
        color: '#ffa022'
      }
    }
  },
  {
    id: 'centroids',
    name: legendData[1],
    type: 'scatter',
    coordinateSystem: 'bmap',
    symbolSize: 10,
    data: [],
    label: {
      normal: {
        formatter: '{b}',
        position: 'right',
        show: false
      }
    },
    itemStyle: {
      normal: {
        color: '#23c6c8'
      }
    }
  }]
  return option
}

export const setDataOption = function (key, data) {
  window.myChat.setOption({
    series: {
      id: key,
      data: data
    }
  })
}

export const setDataPreOption = function (key, data) {
  window.myPreChat.setOption({
    series: {
      id: key,
      data: data
    }
  })
}

const initData = function ({name, data}, index) {
  let delData = {}
  delData.d1 = {
    id: name,
    name: name,
    type: 'lines',
    mapType: 'china',
    coordinateSystem: 'bmap',
    zlevel: 1,
    lineStyle: {
      normal: {
        color: colors[index % colors.length],
        width: 2,
        curveness: 0.2
      }
    },
    data: data
  }
  delData.d2 = {
    id: name + '_p',
    name: name,
    type: 'lines',
    mapType: 'china',
    coordinateSystem: 'bmap',
    zlevel: 2,
    effect: {
      show: true,
      period: 6,
      trailLength: 0,
      symbol: planePath,
      symbolSize: 12
    },
    lineStyle: {
      normal: {
        color: colors[index % colors.length],
        width: 2,
        opacity: 0.4,
        curveness: 0.2
      }
    },
    data: data
  }
  return delData
}

const initPreData = function ({name, data}, index) {
  let delData = {}
  delData.d1 = {
    id: name + index,
    name: name,
    type: 'lines',
    mapType: 'china',
    coordinateSystem: 'bmap',
    zlevel: 1,
    lineStyle: {
      normal: {
        color: colors[index % colors.length],
        width: 2,
        curveness: 0.2
      }
    },
    data: data
  }
  delData.d2 = {
    id: name + index + '_p',
    name: name,
    type: 'lines',
    mapType: 'china',
    coordinateSystem: 'bmap',
    zlevel: 2,
    effect: {
      show: true,
      period: 6,
      trailLength: 0,
      symbol: 'arrow',
      symbolSize: 12
    },
    lineStyle: {
      normal: {
        color: colors[index % colors.length],
        width: 2,
        opacity: 0.4,
        curveness: 0.2
      }
    },
    data: data
  }
  return delData
}

export const addCarData = function (chat, carData) {
  let legendData = []
  let seriesData = []
  carData.forEach(function (item, index) {
    legendData.push(item.name)
    let sData = initData(item, index)
    seriesData.push(sData.d1)
    seriesData.push(sData.d2)
  })
  chat.setOption({series: seriesData})
  if (legendData.length > 0) {
    let option = chat.getOption()
    legendData.sort(function (a, b) {
      return Number(a.slice(2)) - Number(b.slice(2))
    })
    let legend = {
      orient: 'vertical',
      bottom: 20,
      right: 100,
      data: legendData,
      textStyle: {
        color: '#fff'
      }
    }
    option.legend.push(legend)
    chat.setOption(option)
  }
}

export const addCarPreData = function (chat, carData) {
  let seriesData = []
  carData.forEach(function (item, index) {
    let sData = initPreData(item, index)
    seriesData.push(sData.d1)
    seriesData.push(sData.d2)
  })
  chat.setOption({series: seriesData})
}

export const addSourceData = function (chat, carData) {
  if (carData.length === 0) {
    return
  }
  let legendData = []
  let seriesData = []
  carData.forEach(function (item, index) {
    legendData.push(item.name)
    let sData = initData(item, index)
    seriesData.push(sData.d1)
    seriesData.push(sData.d2)
  })
  legendData.sort(function (a, b) {
    return Number(a.slice(2)) - Number(b.slice(2))
  })
  let legend = {
    orient: 'vertical',
    bottom: 20,
    right: 100,
    data: legendData,
    textStyle: {
      color: '#fff'
    }
  }
  let option = chat.getOption()
  option.legend.push(legend)
  chat.setOption({series: seriesData})
  chat.setOption(option)
}



// WEBPACK FOOTER //
// ./src/mapTools.js